import { useState, useEffect, useCallback } from "react";
import $ from 'jquery'

var timeout;
var doHideModal = false;

const modalBridge = {
  open: () => {}
};

export function openModal(message, color, durationSeconds) {
  modalBridge.open(message, color, durationSeconds);
}

function Modal() {

  const [color, setColor] = useState('black')
  const [message, setMessage] = useState('')

  const hideModal = useCallback(() => {
    if (doHideModal) $("#modal").css("display", "none");
  }, []);

  const closeModal = useCallback(() => {
    doHideModal = true;
    $("#modal").animate({
      left: '-50%'
    }, { duration: 700, easing: 'swing', queue: false, complete: function () { hideModal() } });
  }, [hideModal]);

  const showModal = useCallback((modalMessage, modalColor, timeouter = 3) => {
    doHideModal = false;
    setMessage(modalMessage);
    setColor(modalColor);
    $("#modal").css("display", "block");
    $("#modal").animate({
      left: '10px'
    }, { duration: 700, easing: 'swing', queue: false });
    clearTimeout(timeout)
    timeout = setTimeout(function () {
      closeModal()
    }, (timeouter * 1000))
  }, [closeModal]);

  useEffect(() => {
    modalBridge.open = showModal;
    return () => {
      modalBridge.open = () => {};
    };
  }, [showModal]);

  function handleHover() {
    $("#modal").css('cursor', 'pointer')
  }

  return (
    <div id="modal" className="hidden" onClick={closeModal} onMouseMove={handleHover} style={{ backgroundColor: color }}>
      {message}
    </div>
  );
}

export default Modal;
